import * as partnerType from './types';

export const savePartnerName = (name) => ({
	type: partnerType.SAVE_NAME,
	partnerName : name
});
